import { render, staticRenderFns } from "./DirectInputSelect.vue?vue&type=template&id=88670156"
import script from "./DirectInputSelect.vue?vue&type=script&lang=js"
export * from "./DirectInputSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports